import { faAngleRight } from "@jewlr/pro-regular-svg-icons/faAngleRight"
// import { faSparkles } from "@jewlr/pro-regular-svg-icons/faSparkles"
import PropTypes from "prop-types"
import { useMemo } from "react"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
// import { IS_US } from "helpers/application"
import useCountdown from "helpers/use-countdown"
import { cn } from "styles/utils"

import Markdown from "./markdown"
import Segment from "./segment"

const Clock = ({
  Comp,
  compProps,
  isSecondMicroBanner,
  text,
  triggerPopup,
}) => {
  const memoizedTarget = useMemo(() => {
    const nextDay = new Date().setHours(24, 0, 0, 0)

    if (text.end_time) {
      return !text.start_time || new Date() > new Date(text.start_time)
        ? new Date(text.end_time)
        : nextDay
    }

    return nextDay
  }, [text.end_time, text.start_time])

  const { days, hours, minutes, seconds } = useCountdown(memoizedTarget)

  return (
    <Comp data-lc="clock" {...compProps}>
      <div className="tablet:gap-12 flex items-center justify-center gap-16">
        {/* <StyledIcon icon={faSparkles} /> */}
        <div
          className={cn(
            "text-14 inline-block font-normal",
            isSecondMicroBanner ? "tablet:text-16" : "tablet:text-15",
            text.style?.className
          )}
        >
          {text.rich_text ? (
            <Markdown
              classNames={text.style?.classNames}
              defaultClassName="font-bold"
              triggerPopup={triggerPopup}
            >
              {text.rich_text}
            </Markdown>
          ) : (
            <span
              className="font-bold"
              dangerouslySetInnerHTML={{ __html: text.text }}
            />
          )}
          <FontAwesomeIcon
            className="text-12 mx-4 align-baseline"
            icon={faAngleRight}
          />
          <div className="inline-flex align-baseline">
            {days && (
              <>
                <Segment name="days" segment={days} />
                <span>d</span>
                <span className="mx-4" role="separator">
                  |
                </span>
              </>
            )}
            <Segment name="hours" segment={hours} />
            <span>h</span>
            <span className="mx-4" role="separator">
              |
            </span>
            <Segment name="minutes" segment={minutes} />
            <span>m</span>
            <span className="mx-4" role="separator">
              |
            </span>
            <Segment name="seconds" segment={seconds} />
            <span>s</span>
          </div>
        </div>
        {/* <StyledIcon flip="horizontal" icon={faSparkles} /> */}
      </div>
    </Comp>
  )
}

Clock.propTypes = {
  Comp: PropTypes.elementType,
  compProps: PropTypes.object,
  isSecondMicroBanner: PropTypes.bool,
  text: PropTypes.object,
  triggerPopup: PropTypes.func,
}

export default Clock
